export const myTopicsPaths = [
  { locale: 'de', path: 'filter' },
  { locale: 'fr', path: 'filtre' },
];
